import React from "react";
import FavoritesActions from '../actions/favorites-actions';
import FavoritesStore from '../stores/favorites-store';

class FavoriteIcon extends React.Component {

  constructor(props) {
    super(props);
    this.state = { favorited: false };
    this.toggle = this.toggle.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  toggle(event) {
    event.preventDefault();
    var id = this.props.placeId;
    var favorited = FavoritesStore.isFavorite(this.props.placeId);

    if (!favorited) {
      FavoritesActions.add(id);
    } else {
      FavoritesActions.remove(id);
    }
  }

  onChange() {
    this.setState({
      favorited: FavoritesStore.isFavorite(this.props.placeId)
    });
  }

  componentDidMount() {
    FavoritesStore.addChangeListener(this.onChange);
  }
  
  componentWillUnmount() {
    FavoritesStore.removeChangeListener(this.onChange);
  }
  
  render() {
    var favClass = this.state.favorited ? 'favorited' : '';

    return(
        <i className={'fa fa-bookmark '+ favClass} onClick={this.toggle} ></i>
    );
  }
}

FavoriteIcon.propTypes = {
  placeId: React.PropTypes.number.isRequired
};

module.exports = FavoriteIcon;



// WEBPACK FOOTER //
// ./components/favorite-icon.js